import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TextAlignment,
	ThemeProvider,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { Notification } from '@volkswagen-onehub/icons-core';
import React from 'react';
import styled from 'styled-components';
import { PortalContext } from '../../context/portal-context';
import { getUserName } from '../../helpers/nameHelper';
import { useNotificationsTracker } from '../notifications/hooks/use-notifications-tracker';
import { useVehicleNotifications } from '../notifications/hooks/use-vehicle-notifications';
import { HeaderNotificationsLayer } from '../notifications/layers/header-notificaitons-layer';
import { ClubVWLogo2Lines } from './assets/club-vw-logo-2lines';
import { headerImages } from './utils/header-images';

const HeaderBackgroundImage = styled.div<{ $imageBig: string; $imageSmall: string }>`
	// background-image: url(${({ $imageBig }) => $imageBig});
	background-image: url('https://assets.volkswagen.com/is/image/volkswagenag/dashboard_header_bg?Zml0PWNyb3AlMkMxJndpZD0yNTYwJmhlaT0xMjc2JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjFmNDE=');
	background-size: cover;
	background-position: 40% top;
	position: relative;

	// cambio de z-index de los hijos
	& > * {
		position: relative;
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.2);
	}
`;

export function Header() {
	const { portalService } = React.useContext(PortalContext);
	const [image, setImage] = React.useState({ big: '', small: '' });
	const [isLayerOpen, setIsLayerOpen] = React.useState(false);
	const userData = portalService.getPerson().getValue();
	const userName = getUserName(userData);
	const { trackOpenLayerClick } = useNotificationsTracker();

	const notifications = useVehicleNotifications();
	const notificationsCount = notifications.length;

	const handleOpenNotificationsLayer = () => {
		trackOpenLayerClick();
		setIsLayerOpen(true);
	};

	const handleClose = () => {
		setIsLayerOpen(false);
	};

	const getRandomImage = () => {
		const randomIndex = Math.floor(Math.random() * headerImages.length);
		return headerImages[randomIndex];
	};
	React.useEffect(() => {
		setImage(getRandomImage());
	}, []);

	return (
		<HeaderBackgroundImage className="header-background-image" $imageBig={image.big} $imageSmall={image.small}>
			<ThemeProvider theme={'inverted'}>
				<Container
					wrap="always"
					padding={{
						top: ContainerPadding.dynamic0130,
						bottom: {
							[Breakpoints.default]: ContainerPadding.dynamic0130,
							[Breakpoints.b960]: ContainerPadding.dynamic0200,
						},
					}}
				>
					<Container padding={{ left: ContainerPadding.grid001 }}>
						{/* para ClubVWLogo2Lines comprobar si es más pequeño que 560px, si es así poner width: 140px */}
						<ClubVWLogo2Lines width={window.matchMedia('(min-width: 560px)').matches ? 'unset' : '140px'} />
					</Container>
					<Container
						wrap="always"
						padding={{
							left: ContainerPadding.grid001,
							right: ContainerPadding.grid001,
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0350,
								[Breakpoints.b560]: ContainerPadding.dynamic0250,
								[Breakpoints.b1280]: ContainerPadding.dynamic0450,
							},
							bottom: {
								[Breakpoints.default]: ContainerPadding.dynamic0350,
								[Breakpoints.b560]: ContainerPadding.dynamic0250,
								[Breakpoints.b1280]: ContainerPadding.dynamic0450,
							},
						}}
						gutter={ContainerGutter.dynamic0100}
					>
						<Container wrap="never" horizontalAlign={'center'} verticalAlign={'center'}>
							<Text appearance={TokenTextAppearance.headline400} textAlign={TextAlignment.center}>
								Qué alegría verte,
								<Text bold> {userName}</Text>
							</Text>
						</Container>
						{notificationsCount > 0 && (
							<Container wrap="never" horizontalAlign={'center'} verticalAlign={'center'}>
								<CTA tag="button" emphasis="primary" onClick={handleOpenNotificationsLayer}>
									<Notification variant="small" aria-hidden />
									<span style={{ paddingLeft: '7px' }}>
										{notificationsCount} {notificationsCount > 1 ? 'notificaciones' : 'notificación'}
									</span>
								</CTA>
							</Container>
						)}
					</Container>

					<HeaderNotificationsLayer isLayerOpen={isLayerOpen} handleClose={handleClose} notifications={notifications} />
				</Container>
			</ThemeProvider>
		</HeaderBackgroundImage>
	);
}
